// assets
import {
  IconCalendar,
  IconMapPin,
  IconUsers,
  IconFileText,
  IconShield,
  IconChartBar,
  IconSettings,
} from "@tabler/icons-react";

// ==============================|| MENU ITEMS - ADMIN ||============================== //

const icons = {
  IconCalendar,
  IconMapPin,
  IconUsers,
  IconFileText,
  IconShield,
  IconChartBar,
  IconSettings,
};

const admin = {
  id: "admin",
  title: "Admin",
  type: "group",
  children: [
    {
      id: "rallies",
      title: "Rallies",
      type: "item",
      url: "/admin/rallies",
      icon: icons.IconCalendar,
      breadcrumbs: false,
    },
    {
      id: "reports",
      title: "Reports",
      type: "item",
      url: "/admin/reports",
      icon: icons.IconChartBar,
      breadcrumbs: false,
    },
    {
      id: "rally-sites",
      title: "Rally Sites",
      type: "item",
      url: "/admin/rally-sites",
      icon: icons.IconMapPin,
      breadcrumbs: false,
    },
    {
      id: "users",
      title: "Users",
      type: "item",
      url: "/admin/users",
      icon: icons.IconUsers,
      breadcrumbs: false,
    },
    {
      id: "documents",
      title: "Documents",
      type: "item",
      url: "/admin/documents",
      icon: icons.IconFileText,
      breadcrumbs: false,
    },
    {
      id: "gdpr",
      title: "GDPR",
      type: "item",
      url: "/admin/gdpr",
      icon: icons.IconShield,
      breadcrumbs: false,
    },
    {
      id: "general-settings",
      title: "Settings",
      type: "item",
      url: "/admin/general-settings",
      icon: icons.IconSettings,
      breadcrumbs: false,
    },
  ],
};

export default admin;
